import { EntityService } from './EntityService';

export class ProfileService extends EntityService {
    constructor(){
        super('profiles');
    }
}